// @generated by protoc-gen-connect-es v0.8.6 with parameter "target=ts,import_extension="
// @generated from file container/v1/container.proto (package container.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import {
  ArchiveFolderRequest,
  ArchiveFolderResponse,
  CountFoldersRequest,
  CountFoldersResponse,
  CreateFolderRequest,
  CreateFolderResponse,
  DeleteFolderRequest,
  DeleteFolderResponse,
  DeleteFoldersRequest,
  DeleteFoldersResponse,
  GetFolderRequest,
  GetFolderResponse,
  GetOrgRequest,
  GetOrgResponse,
  GetWorkspaceRequest,
  GetWorkspaceResponse,
  ListFoldersRequest,
  ListFoldersResponse,
  ListWorkspacesRequest,
  ListWorkspacesResponse,
  MoveFolderRequest,
  MoveFolderResponse,
  MoveFoldersRequest,
  MoveFoldersResponse,
  RestoreFolderRequest,
  RestoreFolderResponse,
  UpdateFolderRequest,
  UpdateFolderResponse
} from './container_pb'
import { MethodKind } from '@bufbuild/protobuf'

/**
 * Public APIs
 *
 * @generated from service container.v1.ContainerService
 */
export const ContainerService = {
  typeName: 'container.v1.ContainerService',
  methods: {
    /**
     * // Mutations
     *
     * @generated from rpc container.v1.ContainerService.CreateFolder
     */
    createFolder: {
      name: 'CreateFolder',
      I: CreateFolderRequest,
      O: CreateFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.UpdateFolder
     */
    updateFolder: {
      name: 'UpdateFolder',
      I: UpdateFolderRequest,
      O: UpdateFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.ArchiveFolder
     */
    archiveFolder: {
      name: 'ArchiveFolder',
      I: ArchiveFolderRequest,
      O: ArchiveFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.RestoreFolder
     */
    restoreFolder: {
      name: 'RestoreFolder',
      I: RestoreFolderRequest,
      O: RestoreFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.DeleteFolder
     */
    deleteFolder: {
      name: 'DeleteFolder',
      I: DeleteFolderRequest,
      O: DeleteFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.DeleteFolders
     */
    deleteFolders: {
      name: 'DeleteFolders',
      I: DeleteFoldersRequest,
      O: DeleteFoldersResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.MoveFolder
     */
    moveFolder: {
      name: 'MoveFolder',
      I: MoveFolderRequest,
      O: MoveFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.MoveFolders
     */
    moveFolders: {
      name: 'MoveFolders',
      I: MoveFoldersRequest,
      O: MoveFoldersResponse,
      kind: MethodKind.Unary
    },
    /**
     * // Queries
     *
     * @generated from rpc container.v1.ContainerService.GetOrg
     */
    getOrg: {
      name: 'GetOrg',
      I: GetOrgRequest,
      O: GetOrgResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.GetWorkspace
     */
    getWorkspace: {
      name: 'GetWorkspace',
      I: GetWorkspaceRequest,
      O: GetWorkspaceResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.GetFolder
     */
    getFolder: {
      name: 'GetFolder',
      I: GetFolderRequest,
      O: GetFolderResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.ListWorkspaces
     */
    listWorkspaces: {
      name: 'ListWorkspaces',
      I: ListWorkspacesRequest,
      O: ListWorkspacesResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.ListFolders
     */
    listFolders: {
      name: 'ListFolders',
      I: ListFoldersRequest,
      O: ListFoldersResponse,
      kind: MethodKind.Unary
    },
    /**
     * @generated from rpc container.v1.ContainerService.CountFolders
     */
    countFolders: {
      name: 'CountFolders',
      I: CountFoldersRequest,
      O: CountFoldersResponse,
      kind: MethodKind.Unary
    }
  }
} as const
